export default __webpack_public_path__ + "static/media/html5.ea30606a.svg";